import api from "..";
import type {
  IGetDownloadReceiptResponse,
  IGetReceiptRecordResponse,
} from "./type";

export const getLast7DayReceiptList = async (
  parkingId: string | number,
  car_plate: string,
  otp: string,
  phone: string,
) => {
  const response = await api.post<IGetReceiptRecordResponse>(
    `/parking_systems/pays/${parkingId}/last7-by-plate`,
    {
      car_plate: car_plate,
      otp: otp,
      phone: phone,
    },
  );

  return response.data;
};

export const downloadPayReceipts = async (
  parkingId: string | number,
  car_plate: string,
  pay_ids: string[],
) => {
  const response = await api.post<IGetDownloadReceiptResponse>(
    `/parking_systems/pays/${parkingId}/download-receipts`,
    {
      car_plate: car_plate,
      pay_ids: pay_ids,
    },
  );

  return response.data;
};
